import React, { forwardRef } from 'react';
import MuiGrid, {
  Grid2Props as MuiGridProps,
  GridSize as MuiGridSize,
  GridSpacing as MuiGridSpacing
} from '@mui/material/Grid2';
import { BpDesignSystem } from '../../types';

export type GridProps = BpDesignSystem.PropsWithChildren<MuiGridProps & {}>;
export type GridSize = MuiGridSize;
export type GridSpacing = MuiGridSpacing;

export const Grid = forwardRef<HTMLDivElement, GridProps>(({ dataTest, ...props }, ref) => (
  <MuiGrid data-test={dataTest} ref={ref} {...props} />
));
